import React, { useEffect, useState } from 'react'

interface ToastProps {
  show: boolean
  message: string
  duration?: number
}

export const Toast: React.FC<ToastProps> = ({ show, message, duration = 3000 }) => {
  const [visible, setVisible] = useState(show)

  useEffect(() => {
    if (show) {
      setVisible(true)
      const timer = setTimeout(() => {
        setVisible(false)
      }, duration)
      return () => clearTimeout(timer)
    } else {
      setVisible(false)
    }
  }, [show, duration])

  if (!visible) return null

  return (
    <div className="toast toast-show">
      <span>{message}</span>
    </div>
  )
}
